import moment from 'moment';

// My Coaches deliberately keeps the original claim model: an unconditional claim, with a standing
// claim younger than this window prompting a re-claim confirmation. Only the Pool Queue runs the
// conditional claim / release / take-over trio, where a claim never expires.
const SECTION_CLAIM_VALIDITY_HOURS = 1;

const checkHasValidClaim = ({ claimedBy, claimedAt }) => !!claimedBy && !!claimedAt
  && moment().diff(moment.unix(claimedAt.seconds), 'hours') < SECTION_CLAIM_VALIDITY_HOURS;

const checkIsPriorityClaim = (claimedAt) => {
  const now = moment();
  const claimed = moment.unix(claimedAt.seconds);
  const diffInHours = now.diff(claimed, 'hours');

  return diffInHours > 24;
};

export { checkHasValidClaim, checkIsPriorityClaim };
